import { Card } from '@mui/material';
import type { GridRowsProp } from '@mui/x-data-grid';
import { useAtom } from 'jotai';

import ContentNotification from '@/components/ContentNotfication';
import TableWidget from '@/components/TableWidget';
import { PAGE_SIZES } from '@/constants/common';
import type { TableColumn } from '@/features/OrganizationTable/OrganizationsTable.types';
import { getProductCell } from '@/pages/Administration/AdministrationProducts';
import {
  type ProductDTO,
  selectedOrganizationAtom
} from '@/pages/Organizations';

const AdministrationProducts = () => {
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);

  const columns = [
    {
      field: 'product_name',
      headerName: 'Product Name',
      flex: 1,
      minWidth: 150
    },
    {
      field: 'product_type',
      headerName: 'Product Type',
      width: 300,
      renderCell: (params: { row: ProductDTO }) =>
        getProductCell({ id: 'product_type' } as TableColumn, params.row)
    },
    {
      field: 'subscription',
      headerName: 'Subscription',
      width: 300,
      sortable: false,
      renderCell: (params: { row: ProductDTO }) =>
        getProductCell({ id: 'subscription' } as TableColumn, params.row)
    },
    {
      field: 'start_date',
      headerName: 'Product Start',
      width: 300,
      renderCell: (params: { row: ProductDTO }) =>
        getProductCell({ id: 'start_date' } as TableColumn, params.row)
    },
    {
      field: 'end_date',
      headerName: 'Product End',
      width: 300,
      renderCell: (params: { row: ProductDTO }) =>
        getProductCell({ id: 'end_date' } as TableColumn, params.row)
    }
  ];

  return (
    <>
      {/* User with "All" dropdown options should never be able to see this page, but if one does it will request them to select an org */}
      {!selectedOrganization?.products && (
        <ContentNotification
          title="Select an organization"
          text="Please select an organization to view its products."
        />
      )}
      {selectedOrganization?.products && (
        <Card sx={{ height: '100%' }}>
          <TableWidget
            columns={columns}
            rows={selectedOrganization?.products as GridRowsProp}
            header
            loading={false}
            title="Products"
            cellAlignment="center"
            pageSizeOptions={PAGE_SIZES}
            rowHeight={60}
          />
        </Card>
      )}
    </>
  );
};

export default AdministrationProducts;
